module.exports = __webpack_public_path__ + "assets/img/index-intro-01@2x.23a2e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-01@2x.png
// module id = 901
// module chunks = 1